import Checkbox, { CheckboxProps } from '../Checkbox';

import style from './checkbox-group.module.css';

interface CheckboxGroupProps {
  label: string;
  options: CheckboxProps[];
}

const CheckboxGroup = ({
  label,
  options,
}: CheckboxGroupProps) => {
  const checkboxes = (
    <div className={style.options}>
      {options.map((option, index) => (
        <Checkbox
          key={option.id ?? option.name ?? index}
          {...option}
        />
      ))}
    </div>
  );

  if (options.length === 1) {
    return checkboxes;
  }

  return (
    <fieldset className={style.fieldset}>
      <legend>{label}</legend>

      {checkboxes}
    </fieldset>
  );
};

export default CheckboxGroup;
